import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerInformacaoContratual(): void {

  const modules = [
    {
      entry: 'analise-atendimentos',
      id: 'analise-atendimentos',
      name: 'stipulator.analise-atendimentos',
      route: APPLICATION_ROUTES.ANALISE_ATENDIMENTOS,
      closeable: true,
    },
    {
      entry: 'historico-analises',
      id: 'historico-analises',
      name: 'stipulator.historico-analises',
      route: APPLICATION_ROUTES.HISTORICO_ANALISES,
      closeable: true,
    },
    {
      entry: 'historico-autorizacao',
      id: 'historico-autorizacao',
      name: 'stipulator.historico-autorizacao',
      route: APPLICATION_ROUTES.HISTORICO_AUTORIZACAO,
      closeable: true,
    },
    {
      entry: 'historico-requisicao',
      id: 'historico-requisicao',
      name: 'stipulator.historico-requisicoes',
      route: APPLICATION_ROUTES.HISTORICO_REQUISICOES,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'atendimento',
    id: 'atendimento',
    name: 'stipulator.atendimentos',
    modules,
    order: 6,
    closeable: true,
  });
}
